import { render } from "./VectorCoasters.vue?vue&type=template&id=6b2209be&scoped=true"
import script from "./VectorCoasters.vue?vue&type=script&lang=js"
export * from "./VectorCoasters.vue?vue&type=script&lang=js"

import "./VectorCoasters.vue?vue&type=style&index=0&id=6b2209be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2209be"]])

export default __exports__